import React from 'react';
import PropTypes from 'prop-types';
import '../css/ApiKeyLoader.css';

function ApiKeyLoader({ heading, description }) {
    return (
        <div className="api-key-loader">
            <div className="loader-spinner"></div>
            <h3>{heading}</h3>
            <p>{description}</p>
        </div>
    );
}

ApiKeyLoader.propTypes = {
    heading: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export default ApiKeyLoader;

